import React, { useRef, useState } from "react";
import Style from "../ContractStaff.module.scss";
import FilterDropDown from "../FilterDropDown";

const TableHeader = ({ isActiveDropdown, setIsActiveDropdown, handleStaffFilter }) => {
  return (
    <>
      <thead className={Style.AddStaffList__header}>
        <tr>
          <th className={Style.AddStaffList__headerItem}><span>Name</span></th>
          <th className={Style.AddStaffList__headerItem}><span>Mobile Number</span></th>
          <th className={Style.AddStaffList__headerItem}><span>Email id</span></th>
          <th className={Style.AddStaffList__headerItem}><span>Designations</span></th>
          <th className={Style.AddStaffList__headerItem}>
            <FilterDropDown
              isActiveDropdown={isActiveDropdown}
              setIsActiveDropdown={setIsActiveDropdown}
              handleStaffFilter={handleStaffFilter}
            />
          </th>
          <th className={Style.AddStaffList__headerItem}></th>
        </tr>
      </thead>
    </>
  );
}

export default TableHeader;
